// extracted by mini-css-extract-plugin
module.exports = {"cursor":"Cursor_cursor__lZqkl","global":"Cursor_global__aHiYR","mobile":"Cursor_mobile__pz3Nn","hidden":"Cursor_hidden__Rv8_0","copy":"Cursor_copy__Kf9Rv"};